// Payment channel options for payment forms
export const PAYMENT_CHANNELS = [
  'BCA Grace',
  'BCA Grace Backup',
  'Mandiri IIW IDR',
  'Grace Mandiri IDR',  
  'BCA Justin',
  'BCA Eka',
  'WynderOps',
  'Cash'
];